import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "buttonHolder" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "carouselDisplay" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "carouselTextHolder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "carouselText" })
  ])
], -1)
const _hoisted_3 = { class: "buttonHolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "carouselHolder",
    onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseEnter && _ctx.mouseEnter(...args))),
    onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseLeave && _ctx.mouseLeave(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "carouselButton leftButton",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.btnLeftClick && _ctx.btnLeftClick(...args)))
      })
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "carouselButton rightButton",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.btnRightClick && _ctx.btnRightClick(...args)))
      })
    ])
  ], 32))
}